import { ObservationValue } from "@tellescope/types-models";
import { SegmentedBadge, SegmentedBadgeStatus } from "@tellescope/ui";
import type { CombinedClassification } from "@tellescope/tanstack-query";
import { CLASSIFICATION_CLASS_NAMES } from "./styles";

const CLASSIFICATION_TO_STATUS_MAP: Record<string, SegmentedBadgeStatus> = {
  Target: "success",
  High: "warning",
  "Very High": "error",
  "Critical High": "alert",
  Low: "warning",
  "Very Low": "error",
  "Critical Low": "alert",
} as const;

export interface ValuesCellProps {
  measurementsWithClassifications: { measurement: ObservationValue; classification?: CombinedClassification }[];
  className?: string;
}

export const ValuesCell = ({ measurementsWithClassifications, className }: ValuesCellProps) => {
  return (
    <SegmentedBadge
      segments={measurementsWithClassifications.map(({ measurement, classification }) => {
        return {
          value: measurement.value,
          unit: measurement.unit,
          status: classification?.classification
            ? CLASSIFICATION_TO_STATUS_MAP[classification.classification]
            : undefined,
          className: classification?.classification
            ? CLASSIFICATION_CLASS_NAMES[classification?.classification]
            : undefined,
        };
      })}
      className={className}
    />
  );
};
